import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
  Box,
} from "@mui/material";

import Api from "../api/Api";
import { BASE_API_URL } from "../api/const";
import { Film, Media, Genre } from "../types/interfaces";

type Props = {
  film: Film;
  moviesStore: any;
  onClose: () => void;
  open: boolean; // Добавляем пропс для управления открытием
};

const DeleteFilmModal: React.FC<Props> = ({
  film,
  moviesStore,
  onClose,
  open,
}) => {
  const [confirmText, setConfirmText] = useState("");
  const [secondConfirm, setSecondConfirm] = useState(false);

  const handleClose = () => {
    setConfirmText("");
    setSecondConfirm(false);
    onClose();
  };

  const handleDelete = async () => {
    try {
      await Api.post(`${BASE_API_URL}/movies/delete`, {
        movie_id: film.id,
      });
      moviesStore.repeatLastPortalQuery();
      handleClose();
    } catch (err) {
      console.error("Ошибка при удалении фильма", err);
      alert("Ошибка при удалении фильма");
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      if (!secondConfirm) {
        if (confirmText.trim() === "да") {
          setSecondConfirm(true);
        }
      } else {
        handleDelete();
      }
    }
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
        <DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>
          {film.title}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <img
              src={film.logo}
              alt={film.title}
              style={{ maxHeight: 120, maxWidth: "100%" }}
            />
          </Box>

          {!secondConfirm ? (
            <>
              <Typography
                variant="body2"
                align="center"
                sx={{ mb: 1, fontWeight: "bold" }}
              >
                Для того чтобы удалить, введите <b>да</b> с клавиатуры
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={confirmText}
                onChange={(e) => {
                  const newValue = e.target.value;
                  // Блокируем вставку больше 1 символа за раз
                  if (newValue.length > confirmText.length + 1) {
                    return;
                  }
                  setConfirmText(newValue);
                }}
                onPaste={(e) => e.preventDefault()}
                onKeyDown={(e) => {
                  if ((e.ctrlKey || e.metaKey) && e.key === "v") {
                    e.preventDefault();
                  }
                  if (e.key === "Enter" && confirmText.trim() === "да") {
                    setSecondConfirm(true);
                  }
                }}
                placeholder="Введите да"
                autoFocus
                autoComplete="off"
                inputProps={{
                  autoComplete: "off",
                  "aria-autocomplete": "none",
                  maxLength: 2,
                }}
              />
              {confirmText.length > 0 &&
                confirmText !== "да" &&
                confirmText !== "да" && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ display: "block", textAlign: "center", mt: 1 }}
                  >
                    Введите именно "да" с клавиатуры
                  </Typography>
                )}
            </>
          ) : (
            <Typography variant="body2" align="center" sx={{ mb: 2 }}>
              Вы действительно хотите удалить файл <b>{film.title}</b>?
            </Typography>
          )}
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
          {!secondConfirm ? (
            <Button
              variant="contained"
              color="error"
              disabled={confirmText.trim() !== "да"}
              onClick={() => setSecondConfirm(true)}
            >
              Продолжить
            </Button>
          ) : (
            <>
              <Button
                variant="contained"
                onClick={() => setSecondConfirm(false)}
                autoFocus
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setSecondConfirm(false);
                  }
                }}
              >
                Нет
              </Button>
              <Button variant="contained" color="error" onClick={handleDelete}>
                Да, удалить
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteFilmModal;
